// =============================================================================
// LEAD QUALITY DASHBOARD - API CLIENT
// =============================================================================

import type { LeadQualityStats, CallRecord, PaginationInfo } from './types'

const BASE_URL = '/dashboard/lead-quality'

interface FetchCallsParams {
  date_filter?: string
  from_date?: string
  to_date?: string
  page?: number
  per_page?: number
  search?: string
}

interface CallsResponse {
  calls: CallRecord[]
  pagination: PaginationInfo
}

/**
 * Fetch stats for the dashboard
 */
export async function fetchStats(params: {
  date_filter?: string
  from_date?: string
  to_date?: string
}): Promise<LeadQualityStats> {
  const searchParams = new URLSearchParams()
  if (params.date_filter) searchParams.set('date_filter', params.date_filter)
  if (params.from_date) searchParams.set('from_date', params.from_date)
  if (params.to_date) searchParams.set('to_date', params.to_date)

  const response = await fetch(`${BASE_URL}/stats?${searchParams.toString()}`)
  if (!response.ok) {
    throw new Error('Failed to fetch stats')
  }
  return response.json()
}

/**
 * Fetch paginated calls
 */
export async function fetchCalls(params: FetchCallsParams): Promise<CallsResponse> {
  const searchParams = new URLSearchParams()
  if (params.date_filter) searchParams.set('date_filter', params.date_filter)
  if (params.from_date) searchParams.set('from_date', params.from_date)
  if (params.to_date) searchParams.set('to_date', params.to_date)
  if (params.page) searchParams.set('page', params.page.toString())
  if (params.per_page) searchParams.set('per_page', params.per_page.toString())
  if (params.search) searchParams.set('search', params.search)

  const response = await fetch(`${BASE_URL}/calls?${searchParams.toString()}`)
  if (!response.ok) {
    throw new Error('Failed to fetch calls')
  }
  return response.json()
}

/**
 * Get export URL for CSV download
 */
export function getExportUrl(params: {
  date_filter?: string
  from_date?: string
  to_date?: string
}): string {
  const searchParams = new URLSearchParams()
  if (params.date_filter) searchParams.set('date_filter', params.date_filter)
  if (params.from_date) searchParams.set('from_date', params.from_date)
  if (params.to_date) searchParams.set('to_date', params.to_date)
  searchParams.set('format', 'csv')

  return `${BASE_URL}/export.csv?${searchParams.toString()}`
}
